var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dashboard-block" }, [
    _c("ul", { staticClass: "item-detail item-detail-package" }, [
      _c("li", [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6 m-t-xs" }, [
            _c("h3", [_vm._v("Save as PDF")]),
            _vm._v(" "),
            !_vm.$vlastMode
              ? _c("p", [
                  _vm._v(
                    "Show friends and event organisers the progress of your request."
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.$userIsAdmin
            ? _c(
                "div",
                { staticClass: "col-xs-12 col-sm-8 col-lg-3 spacer-y-1" },
                [
                  _c("selectize", {
                    staticClass: "selectize selectize-control selectize-single",
                    attrs: {
                      name: "marketing_source_admin",
                      "disable-delete": true,
                      placeholder: "Audience",
                      options: _vm.audience,
                    },
                    model: {
                      value: _vm.target,
                      callback: function ($$v) {
                        _vm.target = $$v
                      },
                      expression: "target",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-4 col-lg-3 spacer-y-1",
              class: { "col-md-offset-3": !_vm.$userIsAdmin },
            },
            [
              _c(
                "ladda-button",
                {
                  staticClass: "btn btn-primary pull-right w-full",
                  attrs: { button: "", click: _vm.handleDownloadPdfCallback },
                },
                [
                  _c("i", { staticClass: "fa fa-cloud-download" }),
                  _vm._v(" Download\n              "),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }